<template>
    <div id="popup" aria-hidden="true" class="popup popup-filter">
        <div class="popup__wrapper">
            <div class="popup__content">
                <div class="popup__top top-popup top-popup-filter">
                    <div class="top-popup__left top-popup__left--filter">
                        <span>{{ 'All Filters' | trans }}</span>
                    </div>
                    <button
                        type="button"
                        data-close
                        class="popup__close popup__close--filters"
                    ></button>
                </div>
                <form action="" class="popup-filter__form form-filter-popup">
                    <div class="form-filter-popup__body">
                        <!-- Property type -->
                        <div class="form-filter-popup__item">
                            <div class="form-filter-popup__title">{{ 'Property type' | trans }}:</div>
                            <div
                                key="propertyTypesFilterPopup"
                                class="form-filter-popup__select custom-select-filter"
                                :class="{'_open': openedFilters.propertyTypesFilter}"
                            >
                                <button
                                    type="button"
                                    key="propertyTypesFilterSelectedPopup"
                                    class="custom-select-filter__title"
                                    @click="hideShowFilterSelected('propertyTypesFilter')"
                                >
                                    <span
                                        key="anySelectedPropertyTypePopupLine"
                                        v-if="localSelectedPropertyTypes.length === 0"
                                        class="custom-select-filter__title-any"
                                    >
                                        {{ 'Any type' | trans }}
                                    </span>
                                    <span v-else key="selectedPropertyTypesPopup">
                                        {{ printSelectedItems(localSelectedPropertyTypes) }}
                                    </span>
                                </button>
                                <div class="custom-select-filter__body">
                                    <div
                                        key="propertyTypesFilterBodyPopup"
                                        class="custom-select-filter__content"
                                        :class="{'d-none': !openedFilters.propertyTypesFilter}"
                                    >
                                        <div
                                            v-for="propertyType in allPropertyTypes"
                                            :key="'propertyTypePopup' + propertyType.id"
                                            class="select-checkbox"
                                            @click="toggleItem(localSelectedPropertyTypes, propertyType)"
                                        >
                                            <input type="checkbox" :checked="isSelectedItem(propertyType, localSelectedPropertyTypes)">
                                            <label for="">{{ propertyType.title }}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Rooms (C2: show "Studio" for 0, multi-select) -->
                        <div class="form-filter-popup__item">
                            <div class="form-filter-popup__title">{{ 'Rooms' | trans }}:</div>
                            <div class="form-filter-popup__options options options_round">
                                <div v-for="n in uniqueBedroomsNumbers" :key="'room_' + n" class="options__item">
                                    <input
                                        type="checkbox"
                                        :id="'room_' + n"
                                        class="options__input"
                                        :checked="localSelectedBedroomsNumbers.includes(n)"
                                        @change="toggleIdInArray(localSelectedBedroomsNumbers, n)"
                                    >
                                    <label :for="'room_' + n" class="options__label">
                                        <span class="options__text">
                                            {{ n === 0 ? ($options.filters.trans('Studio')) : n }}
                                        </span>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <!-- Bathrooms (C2: show "No" for 0, multi-select) -->
                        <div class="form-filter-popup__item">
                            <div class="form-filter-popup__title">{{ 'Bathrooms' | trans }}:</div>
                            <div class="form-filter-popup__options options options_round">
                                <div v-for="n in uniqueBathroomsNumbers" :key="'bathroom_' + n" class="options__item">
                                    <input
                                        type="checkbox"
                                        :id="'bathroom_' + n"
                                        class="options__input"
                                        :checked="localSelectedBathroomsNumbers.includes(n)"
                                        @change="toggleIdInArray(localSelectedBathroomsNumbers, n)"
                                    >
                                    <label :for="'bathroom_' + n" class="options__label">
                                        <span class="options__text">
                                            {{ n === 0 ? ($options.filters.trans('No')) : n }}
                                        </span>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <!-- Price (C3: dynamic range + Per m² toggle) -->
                        <div class="form-filter-popup__item">
                            <div class="form-filter-popup__title">{{ 'Price' | trans }}:</div>
                            <div class="form-filter-popup__price price-form-filter">
                                <div class="price-form-filter__top">
                                    <div class="price-form-filter__left">
                                        <div class="price-form-filter__wp">
                                            <input
                                                type="number"
                                                :placeholder="priceMin"
                                                id="price-start"
                                                name="form[]"
                                                class="price-form-filter__input input-number-0"
                                                v-model="localSelectedMinPrice"
                                            >
                                        </div>
                                        <img :src="currencyIconSrc" alt="">
                                        <div class="price-form-filter__wp">
                                            <input
                                                type="number"
                                                :placeholder="priceMax"
                                                id="price-end"
                                                name="form[]"
                                                class="price-form-filter__input input-number-1"
                                                v-model="localSelectedMaxPrice"
                                            >
                                        </div>
                                        <img :src="currencyIconSrc" alt="">
                                    </div>
                                    <div class="price-form-filter__right price-form-filter__right--pc">
                                        <div class="options__item">
                                            <input
                                                type="radio"
                                                id="sorting_price_1_pc"
                                                class="options__input"
                                                :value="false"
                                                name="sorting_price_pc"
                                                v-model="localSelectedPricePerMeter"
                                            >
                                            <label for="sorting_price_1_pc" class="options__label">
                                                <span class="options__text">{{ 'Per object' | trans }}</span>
                                            </label>
                                        </div>
                                        <div class="options__item">
                                            <input
                                                type="radio"
                                                id="sorting_price_2_pc"
                                                class="options__input"
                                                :value="true"
                                                name="sorting_price_pc"
                                                v-model="localSelectedPricePerMeter"
                                            >
                                            <label for="sorting_price_2_pc" class="options__label">
                                                <span v-if="measurementUnitSystem === 'imperial'" class="options__text">{{ 'Per ft2' | trans }}</span>
                                                <span v-else class="options__text">{{ 'Per m2' | trans }}</span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="price-form-filter__range_wp">
                                    <div class="price-form-filter__range"></div>
                                </div>
                                <div class="price-form-filter__right price-form-filter__right--mob">
                                    <div class="options__item">
                                        <input
                                            type="radio"
                                            id="sorting_price_1_mob"
                                            class="options__input"
                                            :value="false"
                                            name="sorting_price_mob"
                                            v-model="localSelectedPricePerMeter"
                                        >
                                        <label for="sorting_price_1_mob" class="options__label">
                                            <span class="options__text">{{ 'Per object' | trans }}</span>
                                        </label>
                                    </div>
                                    <div class="options__item">
                                        <input
                                            type="radio"
                                            id="sorting_price_2_mob"
                                            class="options__input"
                                            :value="true"
                                            name="sorting_price_mob"
                                            v-model="localSelectedPricePerMeter"
                                        >
                                        <label for="sorting_price_2_mob" class="options__label">
                                            <span v-if="measurementUnitSystem === 'imperial'" class="options__text">{{ 'Per ft2' | trans }}</span>
                                            <span v-else class="options__text">{{ 'Per m2' | trans }}</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- District -->
                        <div class="form-filter-popup__item">
                            <div class="form-filter-popup__title">{{ 'District' | trans }}:</div>
                            <div
                                key="districtsFilterPopup"
                                class="form-filter-popup__select custom-select-filter"
                                :class="{'_open': openedFilters.districtsFilter}"
                            >
                                <button
                                    type="button"
                                    key="districtsFilterSelectedPopup"
                                    class="custom-select-filter__title"
                                    @click="hideShowFilterSelected('districtsFilter')"
                                >
                                    <span
                                        class="custom-select-filter__title-any"
                                        v-if="localSelectedDistricts.length === 0"
                                        key="anySelectedDistrictPopup"
                                    >
                                        {{ 'Any district' | trans }}
                                    </span>
                                    <span v-else key="selectedDistrictsPopup">
                                        {{ printSelectedItems(localSelectedDistricts) }}
                                    </span>
                                </button>
                                <div
                                    key="districtsFilterBodyPopup"
                                    class="custom-select-filter__body"
                                    :class="{'d-none': !openedFilters.districtsFilter}"
                                >
                                    <div class="custom-select-filter__content">
                                        <div
                                            key="anySelectedDistrictPopupList"
                                            class="select-checkbox"
                                            :class="{'_selected': areAllDistrictsChecked}"
                                            @click="toggleItem(localSelectedDistricts)"
                                        >
                                            <label for="">{{ 'Any district' | trans }}</label>
                                        </div>
                                        <div
                                            v-for="district in allDistricts"
                                            :key="'districtPopup' + district.id"
                                            class="select-checkbox"
                                            :class="{'_selected': isSelectedItem(district, localSelectedDistricts)}"
                                            @click="toggleItem(localSelectedDistricts, district)"
                                        >
                                            <input type="checkbox" :checked="isSelectedItem(district, localSelectedDistricts)">
                                            <label for="">{{ district.title }}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Builder -->
                        <div class="form-filter-popup__item">
                            <div class="form-filter-popup__title">{{ 'Builder' | trans }}:</div>
                            <div
                                key="buildersFilter"
                                class="form-filter-popup__select custom-select-filter"
                                :class="{'_open': openedFilters.buildersFilter}"
                            >
                                <button
                                    key="buildersFilterSelected"
                                    type="button"
                                    class="custom-select-filter__title"
                                    @click="hideShowFilterSelected('buildersFilter')"
                                >
                                    <span
                                        class="custom-select-filter__title-any"
                                        v-if="localSelectedBuilders.length === 0"
                                        key="anySelectedBuilder"
                                    >
                                        {{ 'Any builder' | trans }}
                                    </span>
                                    <span v-else key="selectedBuildersPopup">
                                        {{ printSelectedItems(localSelectedBuilders) }}
                                    </span>
                                </button>
                                <div
                                    key="buildersFilterBody"
                                    class="custom-select-filter__body"
                                    :class="{'d-none': !openedFilters.buildersFilter}"
                                >
                                    <div class="custom-select-filter__content">
                                        <div
                                            key="anySelectedBuilderPopupList"
                                            class="select-checkbox"
                                            :class="{'_selected': areAllBuildersChecked}"
                                            @click="toggleItem(localSelectedBuilders)"
                                        >
                                            <label for="">{{ 'Any builder' | trans }}</label>
                                        </div>
                                        <div
                                            v-for="builder in allBuilders"
                                            :key="'builder' + builder.id"
                                            class="select-checkbox"
                                            :class="{'_selected': isSelectedItem(builder, localSelectedBuilders)}"
                                            @click="toggleItem(localSelectedBuilders, builder)"
                                        >
                                            <input type="checkbox" :checked="isSelectedItem(builder, localSelectedBuilders)">
                                            <label for="">{{ builder.title }}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Complex (C1: filtered by selected builders) -->
                        <div class="form-filter-popup__item">
                            <div class="form-filter-popup__title">{{ 'Complex' | trans }}:</div>
                            <div
                                key="complexesFilter"
                                class="form-filter-popup__select custom-select-filter"
                                :class="{'_open': openedFilters.complexesFilter}"
                            >
                                <button
                                    key="complexesFilterSelected"
                                    type="button"
                                    class="custom-select-filter__title"
                                    @click="hideShowFilterSelected('complexesFilter')"
                                >
                                    <span
                                        class="custom-select-filter__title-any"
                                        v-if="localSelectedComplexes.length === 0"
                                        key="anySelectedComplex"
                                    >
                                        {{ 'Any complex' | trans }}
                                    </span>
                                    <span v-else key="selectedComplexes">
                                        {{ printSelectedItems(localSelectedComplexes) }}
                                    </span>
                                </button>
                                <div
                                    key="complexesFilterBody"
                                    class="custom-select-filter__body"
                                    :class="{'d-none': !openedFilters.complexesFilter}"
                                >
                                    <div class="custom-select-filter__content">
                                        <div
                                            key="anySelectedComplexPopupList"
                                            class="select-checkbox"
                                            :class="{'_selected': areAllComplexesChecked}"
                                            @click="toggleItem(localSelectedComplexes)"
                                        >
                                            <label for="">{{ 'Any complex' | trans }}</label>
                                        </div>
                                        <div
                                            v-for="complex in filteredComplexes"
                                            :key="'complex' + complex.id"
                                            class="select-checkbox"
                                            :class="{'_selected': isSelectedItem(complex, localSelectedComplexes)}"
                                            @click="toggleItem(localSelectedComplexes, complex)"
                                        >
                                            <input type="checkbox" :checked="isSelectedItem(complex, localSelectedComplexes)">
                                            <label for="">{{ complex.title }}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Furniture (C4: radio checkboxes wired to store) -->
                        <div class="form-filter-popup__item">
                            <div class="form-filter-popup__title">{{ 'Furniture' | trans }}:</div>
                            <div class="filter-options">
                                <div class="options__item">
                                    <input
                                        type="checkbox"
                                        id="furniture_full"
                                        class="options__input"
                                        :checked="localSelectedFurnitureType === 'full'"
                                        @change="toggleFurniture('full')"
                                    >
                                    <label for="furniture_full" class="options__label">
                                        <span class="options__text">{{ 'There is furniture' | trans }}</span>
                                    </label>
                                </div>
                                <div class="options__item">
                                    <input
                                        type="checkbox"
                                        id="furniture_none"
                                        class="options__input"
                                        :checked="localSelectedFurnitureType === 'none'"
                                        @change="toggleFurniture('none')"
                                    >
                                    <label for="furniture_none" class="options__label">
                                        <span class="options__text">{{ 'No furniture' | trans }}</span>
                                    </label>
                                </div>
                                <div class="options__item">
                                    <input
                                        type="checkbox"
                                        id="furniture_kitchen"
                                        class="options__input"
                                        :checked="localSelectedFurnitureType === 'kitchen_only'"
                                        @change="toggleFurniture('kitchen_only')"
                                    >
                                    <label for="furniture_kitchen" class="options__label">
                                        <span class="options__text">{{ 'Only kitchen' | trans }}</span>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <!-- Facilities (C5: dynamic convenience groups + standalone) -->
                        <div class="form-filter-popup__item" v-if="allConvenienceGroups.length || standaloneConveniences.length">
                            <div class="form-filter-popup__title">{{ 'Facilities' | trans }}:</div>
                            <div class="filter-options">
                                <!-- Groups -->
                                <template v-for="group in allConvenienceGroups">
                                    <div
                                        :key="'group' + group.id"
                                        class="options__item"
                                    >
                                        <input
                                            type="checkbox"
                                            :id="'group_' + group.id"
                                            class="options__input"
                                            :checked="localSelectedConvenienceGroupIds.includes(group.id)"
                                            @change="toggleIdInArray(localSelectedConvenienceGroupIds, group.id)"
                                        >
                                        <label :for="'group_' + group.id" class="options__label">
                                            <span class="options__text">{{ group.title }}</span>
                                        </label>
                                    </div>
                                </template>
                                <!-- Standalone conveniences -->
                                <template v-for="convenience in standaloneConveniences">
                                    <div
                                        :key="'conv' + convenience.id"
                                        class="options__item"
                                    >
                                        <input
                                            type="checkbox"
                                            :id="'conv_' + convenience.id"
                                            class="options__input"
                                            :checked="localSelectedStandaloneConvenienceIds.includes(convenience.id)"
                                            @change="toggleIdInArray(localSelectedStandaloneConvenienceIds, convenience.id)"
                                        >
                                        <label :for="'conv_' + convenience.id" class="options__label">
                                            <span class="options__text">{{ convenience.title }}</span>
                                        </label>
                                    </div>
                                </template>
                            </div>
                        </div>

                        <!-- Completion status -->
                        <div class="form-filter-popup__item">
                            <div class="form-filter-popup__title">{{ 'Completion status' | trans }}:</div>
                            <div class="filter-options">
                                <div class="options__item">
                                    <input
                                        type="checkbox"
                                        id="c_true"
                                        class="options__input"
                                        v-model="isFinished"
                                        @change="updateIsFinished"
                                    >
                                    <label for="c_true" class="options__label">
                                        <span class="options__text">{{ 'Completed' | trans }}</span>
                                    </label>
                                </div>
                                <div class="options__item">
                                    <input
                                        type="checkbox"
                                        id="c_false"
                                        class="options__input"
                                        v-model="notFinished"
                                        @change="updateIsFinished"
                                    >
                                    <label for="c_false" class="options__label">
                                        <span class="options__text">{{ 'Not yet completed' | trans }}</span>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <!-- Tags (C6: dynamic) -->
                        <div class="form-filter-popup__item" v-if="allTags.length">
                            <div class="form-filter-popup__title">{{ 'Tags' | trans }}:</div>
                            <div class="filter-options">
                                <div
                                    v-for="tag in allTags"
                                    :key="'tag' + tag.id"
                                    class="options__item"
                                >
                                    <input
                                        type="checkbox"
                                        :id="'tag_' + tag.id"
                                        class="options__input"
                                        :checked="localSelectedTagsIds.includes(tag.id)"
                                        @change="toggleIdInArray(localSelectedTagsIds, tag.id)"
                                    >
                                    <label :for="'tag_' + tag.id" class="options__label">
                                        <span class="options__text">{{ tag.title }}</span>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <!-- Search by ID -->
                        <div class="form-filter-popup__item">
                            <div class="form-filter-popup__title">{{ 'Search by ID' | trans }}</div>
                            <div class="form-filter-popup__search search-form-filter">
                                <input
                                    type="text"
                                    :placeholder="'Input ID' | trans"
                                    class="search-form-filter__inp"
                                    v-model="localSelectedPersonalId"
                                >
                                <button type="button" class="search-form-filter__btn _icon-search"></button>
                            </div>
                        </div>
                    </div>
                </form>
                <div class="form-filter-popup__footer footer-form-filter">
                    <button
                        key="resetKey"
                        class="reset-filters"
                        @click="resetSelectedItems"
                    >
                        <img src="/img/reset.svg" alt="">
                        <span>{{ 'Reset filter' | trans }}</span>
                        <span>{{ 'Reset' | trans }}</span>
                    </button>
                    <!-- Apply button with live counter (C7) -->
                    <button
                        type="button"
                        data-close
                        class="blue-btn apply-filters"
                        @click="applyFilteringOptions"
                        :disabled="countLoading"
                    >
                        <!-- first-of-type: shown on desktop, hidden on mobile -->
                        <span>{{ 'Show' | trans }} {{  (countLoading || liveCount === null) ? '...' : liveCount }} {{ 'offers' | trans }}</span>
                        <!-- last-of-type: hidden on desktop, shown on mobile (short label) -->
                        <span>{{ (countLoading || liveCount === null) ? '...' : liveCount }} {{ 'offers' | trans }}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import noUiSlider from 'nouislider';
import { countProperties, countComplexes } from '../../api/catalog';

export default {
    name: "PopupFilter",
    props: {
        options: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            turnOnWatchers: true,
            openedFilters: {
                propertyTypesFilter: false,
                districtsFilter: false,
                buildersFilter: false,
                complexesFilter: false,
            },
            localSelectedPropertyTypes: [],
            localSelectedDistricts: [],
            localSelectedBuilders: [],
            localSelectedComplexes: [],
            localSelectedBedroomsNumbers: [],
            localSelectedBathroomsNumbers: [],
            localSelectedPersonalId: '',
            localSelectedIsFinished: null,
            isFinished: false,
            notFinished: false,
            localSelectedMinPrice: '',
            localSelectedMaxPrice: '',
            localSelectedHighestPrice: null,
            localSelectedLowestPrice: null,
            localSelectedIsNew: null,
            localSelectedIsPopular: null,
            localSelectedFurnitureType: null,
            localSelectedTagsIds: [],
            localSelectedConvenienceGroupIds: [],
            localSelectedStandaloneConvenienceIds: [],
            localSelectedPricePerMeter: false,
            measurementUnitSystem: window.measurementUnitSystem || 'metric',
            liveCount: null,
            countLoading: false,
            countDebounceTimer: null,
            convertedPriceMin: null,
            convertedPriceMax: null,
            convertedPriceMinPerMeter: null,
            convertedPriceMaxPerMeter: null,
        }
    },
    computed: {
        ...mapGetters({
            paginator: 'filtration/paginator',
            selectedPropertyTypesFromStore:          'filtration/selectedPropertyTypes',
            selectedDistrictsFromStore:              'filtration/selectedDistricts',
            selectedBuildersFromStore:               'filtration/selectedBuilders',
            selectedComplexesFromStore:              'filtration/selectedComplexes',
            selectedBedroomsNumbersFromStore:        'filtration/selectedBedroomsNumbers',
            selectedBathroomsNumbersFromStore:       'filtration/selectedBathroomsNumbers',
            selectedPersonalIdFromStore:             'filtration/selectedPersonalId',
            selectedIsFinishedFromStore:             'filtration/selectedIsFinished',
            selectedMinPriceFromStore:               'filtration/selectedMinPrice',
            selectedMaxPriceFromStore:               'filtration/selectedMaxPrice',
            selectedHighestPriceFromStore:           'filtration/selectedHighestPrice',
            selectedLowestPriceFromStore:            'filtration/selectedLowestPrice',
            selectedIsNewFromStore:                  'filtration/selectedIsNew',
            selectedIsPopularFromStore:              'filtration/selectedIsPopular',
            selectedFurnitureTypeFromStore:          'filtration/selectedFurnitureType',
            selectedTagsIdsFromStore:                'filtration/selectedTagsIds',
            selectedConvenienceGroupIdsFromStore:    'filtration/selectedConvenienceGroupIds',
            selectedStandaloneConvenienceIdsFromStore: 'filtration/selectedStandaloneConvenienceIds',
            selectedPricePerMeterFromStore:          'filtration/selectedPricePerMeter',
            defaultMinPriceFromStore:                'filtration/defaultMinPrice',
            defaultMaxPriceFromStore:                'filtration/defaultMaxPrice',
            isPricesConverted:                       'filtration/isPricesConverted',
        }),
        currency() {
            return window.currentCurrency;
        },
        // Options accessors
        allDistricts() { return this.options.allDistricts },
        currencyIconSrc() {
            return window.currencyIconUrl || '/img/volute/usd.svg';
        },
        parsedPersonalIds() {
            if (!this.localSelectedPersonalId) return [];
            const ids = this.localSelectedPersonalId
                .split(/[\s,]+/)
                .map(s => parseInt(s, 10))
                .filter(n => Number.isInteger(n) && !isNaN(n));
            return [...new Set(ids)].slice(0, 10);
        },
        allBuilders()  { return this.options.allBuilders },
        allPropertyTypes() { return this.options.allPropertyTypes },
        uniqueBedroomsNumbers() { return this.options.uniqueBedroomsNumbers },
        uniqueBathroomsNumbers() { return this.options.uniqueBathroomsNumbers },
        allTags() { return this.options.allTags || [] },
        allConvenienceGroups() { return this.options.allConvenienceGroups || [] },
        standaloneConveniences() { return this.options.standaloneConveniences || [] },
        priceRange() { return this.options.priceRange || {} },
        priceMin() {
            const step = this.localSelectedPricePerMeter ? 500 : 50000;
            const raw = this.localSelectedPricePerMeter
                ? (this.convertedPriceMinPerMeter ?? this.priceRange.min_per_meter ?? 0)
                : (this.convertedPriceMin ?? this.priceRange.min ?? 0);
            return Math.floor(raw / step) * step;
        },
        priceMax() {
            const step = this.localSelectedPricePerMeter ? 500 : 50000;
            const raw = this.localSelectedPricePerMeter
                ? (this.convertedPriceMaxPerMeter ?? this.priceRange.max_per_meter ?? 0)
                : (this.convertedPriceMax ?? this.priceRange.max ?? 0);
            return Math.ceil(raw / step) * step;
        },

        // C1: filter complexes by selected builders (own builder_id or builders of its published properties)
        allComplexes() { return this.options.allComplexes },
        filteredComplexes() {
            if (this.localSelectedBuilders.length === 0) return this.allComplexes;
            const builderIds = this.localSelectedBuilders.map(b => b.id);
            return this.allComplexes.filter(c => this.complexBuilderIds(c).some(id => builderIds.includes(id)));
        },

        // "Any" checkers
        areAllPropertyTypesChecked: {
            get() { return this.localSelectedPropertyTypes.length === 0; },
            set(value) { if (value) this.localSelectedPropertyTypes = []; }
        },
        areAllDistrictsChecked: {
            get() { return this.localSelectedDistricts.length === 0; },
            set(value) { if (value) this.localSelectedDistricts = []; }
        },
        areAllBuildersChecked: {
            get() { return this.localSelectedBuilders.length === 0; },
            set(value) { if (value) this.localSelectedBuilders = []; }
        },
        areAllComplexesChecked: {
            get() { return this.localSelectedComplexes.length === 0; },
            set(value) { if (value) this.localSelectedComplexes = []; }
        },

        // Page context helpers (C8)
        isComplexesPage() {
            return window.complexesUrl
                ? window.location.href.startsWith(window.complexesUrl)
                : window.location.pathname.includes('/complexes');
        },
        isPropertiesPage() {
            return window.propertiesUrl
                ? window.location.href.startsWith(window.propertiesUrl)
                : window.location.pathname.includes('/properties-for-sale');
        },
    },
    methods: {
        ...mapActions({
            redirectToPropertiesPage:                     'filtration/redirectToPropertiesPage',
            setSelectedMinPriceToStore:                   'filtration/setSelectedMinPrice',
            setSelectedMaxPriceToStore:                   'filtration/setSelectedMaxPrice',
            setSelectedPropertyTypesToStore:              'filtration/setSelectedPropertyTypes',
            setSelectedDistrictsToStore:                  'filtration/setSelectedDistricts',
            setSelectedIsNewToStore:                      'filtration/setSelectedIsNew',
            setSelectedIsPopularToStore:                  'filtration/setSelectedIsPopular',
            setSelectedLowestPriceToStore:                'filtration/setSelectedLowestPrice',
            setSelectedHighestPriceToStore:               'filtration/setSelectedHighestPrice',
            setSelectedBuildersToStore:                   'filtration/setSelectedBuilders',
            setSelectedComplexesToStore:                  'filtration/setSelectedComplexes',
            setSelectedBedroomsNumbersToStore:            'filtration/setSelectedBedroomsNumbers',
            setSelectedBathroomsNumbersToStore:           'filtration/setSelectedBathroomsNumbers',
            setSelectedPersonalIdToStore:                 'filtration/setSelectedPersonalId',
            setSelectedIsFinishedToStore:                 'filtration/setSelectedIsFinished',
            setSelectedFurnitureTypeToStore:              'filtration/setSelectedFurnitureType',
            setSelectedTagsIdsToStore:                    'filtration/setSelectedTagsIds',
            setSelectedConvenienceGroupIdsToStore:        'filtration/setSelectedConvenienceGroupIds',
            setSelectedStandaloneConvenienceIdsToStore:   'filtration/setSelectedStandaloneConvenienceIds',
            setSelectedPricePerMeterToStore:              'filtration/setSelectedPricePerMeter',
            resetFiltrationParams:                        'filtration/resetFiltrationParams',
        }),

        // Builder ids a complex is related to: own builder_id + builders of its published properties
        complexBuilderIds(complex) {
            return complex.builder_ids || (complex.builder_id ? [complex.builder_id] : []);
        },

        // Toggle object item in array (by id)
        toggleItem(selectedItems, item = null) {
            if (item === null) {
                if (selectedItems.length !== 0) selectedItems.splice(0, selectedItems.length);
                return;
            }
            const index = selectedItems.findIndex(s => s.id === item.id);
            if (index !== -1) selectedItems.splice(index, 1);
            else selectedItems.push(item);
        },

        // Toggle numeric ID in array (for tags, convenience groups, etc.)
        toggleIdInArray(arr, id) {
            const index = arr.indexOf(id);
            if (index !== -1) arr.splice(index, 1);
            else arr.push(id);
        },

        // C4: Furniture behaves like radio (selecting same unchecks)
        toggleFurniture(type) {
            this.localSelectedFurnitureType = this.localSelectedFurnitureType === type ? null : type;
        },

        updateIsFinished() {
            if (this.isFinished && this.notFinished) {
                this.localSelectedIsFinished = null;
            } else if (this.isFinished) {
                this.localSelectedIsFinished = true;
            } else if (this.notFinished) {
                this.localSelectedIsFinished = false;
            } else {
                this.localSelectedIsFinished = null;
            }
        },
        isSelectedItem(item, selectedItems) {
            return selectedItems.some(s => s.id === item.id);
        },
        printSelectedItems(selectedItems) {
            return selectedItems.map(item => item.title).join(', ');
        },
        async resetSelectedItems() {
            this.turnOnWatchers = false;

            // 1. Сбрасываем стор (selectedMinPrice/Max = null, чтобы листинг не применял ценовой фильтр)
            await this.$store.dispatch('filtration/updateSelectedFilters', {
                selectedPropertyTypes:            [],
                selectedDistricts:                [],
                selectedBuilders:                 [],
                selectedComplexes:                [],
                selectedBedroomsNumbers:          [],
                selectedBathroomsNumbers:         [],
                selectedPersonalId:               '',
                selectedIsFinished:               null,
                selectedMinPrice:                 null,
                selectedMaxPrice:                 null,
                selectedHighestPrice:             null,
                selectedLowestPrice:              null,
                selectedIsNew:                    null,
                selectedIsPopular:                null,
                selectedFurnitureType:            null,
                selectedTagsIds:                  [],
                selectedConvenienceGroupIds:      [],
                selectedStandaloneConvenienceIds: [],
                selectedPricePerMeter:            false,
            });

            // 2. Сбрасываем локальные UI-переменные, которые не синхронизируются из стора
            this.isFinished  = false;
            this.notFinished = false;
            // Цены — '' чтобы initSlider выставил их в границы диапазона
            this.localSelectedMinPrice = '';
            this.localSelectedMaxPrice = '';

            // 3. Переинициализируем слайдер на весь диапазон
            this.initSlider();

            this.turnOnWatchers = true;
            this.fetchLiveCount();
        },

        // C8: Smart redirect
        applyFilteringOptions() {
            this.redirectToPropertiesPage();
        },

        hideShowFilterSelected(openedFilter) {
            Object.keys(this.openedFilters).forEach(key => {
                this.openedFilters[key] = key === openedFilter ? !this.openedFilters[key] : false;
            });
        },

        // C7: Live count — builds params and calls the right endpoint
        scheduleLiveCount() {
            clearTimeout(this.countDebounceTimer);
            this.countDebounceTimer = setTimeout(() => this.fetchLiveCount(), 400);
        },

        async fetchLiveCount() {
            this.countLoading = true;
            const params = this.buildCountParams();
            try {
                const count = this.isComplexesPage
                    ? await countComplexes(params)
                    : await countProperties(params);
                this.liveCount = count;
            } finally {
                this.countLoading = false;
            }
        },

        buildCountParams() {
            // Only apply price filter if user moved the slider away from the default range bounds
            const rangeMin = this.convertedPriceMin ?? this.priceRange.min ?? 0;
            const rangeMax = this.convertedPriceMax ?? this.priceRange.max ?? 0;
            const effectiveMin = (this.localSelectedMinPrice !== '' && this.localSelectedMinPrice != rangeMin)
                ? this.localSelectedMinPrice : null;
            const effectiveMax = (this.localSelectedMaxPrice !== '' && this.localSelectedMaxPrice != rangeMax)
                ? this.localSelectedMaxPrice : null;

            // On a category page the current type lives in the URL path, not in the filter state —
            // scope the count to it when the user hasn't picked types explicitly.
            const propertyTypeIds = this.localSelectedPropertyTypes.length
                ? this.localSelectedPropertyTypes.map(t => t.id)
                : (window.currentPropertyTypeId ? [window.currentPropertyTypeId] : []);

            return {
                propertyTypesIds:             JSON.stringify(propertyTypeIds),
                districtsIds:                 JSON.stringify(this.localSelectedDistricts.map(t => t.id)),
                buildersIds:                  JSON.stringify(this.localSelectedBuilders.map(t => t.id)),
                complexesIds:                 JSON.stringify(this.localSelectedComplexes.map(t => t.id)),
                bedroomsNumbers:              JSON.stringify(this.localSelectedBedroomsNumbers),
                bathroomsNumbers:             JSON.stringify(this.localSelectedBathroomsNumbers),
                personalIds:                  JSON.stringify(this.parsedPersonalIds),
                isFinished:                   this.localSelectedIsFinished,
                minPrice:                     this.localSelectedPricePerMeter ? null : effectiveMin,
                maxPrice:                     this.localSelectedPricePerMeter ? null : effectiveMax,
                minPricePerMeter:             this.localSelectedPricePerMeter ? effectiveMin : null,
                maxPricePerMeter:             this.localSelectedPricePerMeter ? effectiveMax : null,
                highestPrice:                 this.localSelectedHighestPrice,
                lowestPrice:                  this.localSelectedLowestPrice,
                isNew:                        this.localSelectedIsNew,
                isPopular:                    this.localSelectedIsPopular,
                furnitureType:                this.localSelectedFurnitureType,
                tagsIds:                      JSON.stringify(this.localSelectedTagsIds),
                convenienceGroupIds:          JSON.stringify(this.localSelectedConvenienceGroupIds),
                standaloneConvenienceIds:     JSON.stringify(this.localSelectedStandaloneConvenienceIds),
                currency:                     window.currentCurrency,
                measurementUnitSystem:        this.measurementUnitSystem,
            };
        },

        initSlider() {
            const priceSlider = document.querySelector(".price-form-filter__range");
            if (!priceSlider) return;

            if (priceSlider.noUiSlider) priceSlider.noUiSlider.destroy();

            // Use converted values if available, otherwise raw DB values
            const STEP = this.localSelectedPricePerMeter ? 500 : 50000;
            const rawMin = this.localSelectedPricePerMeter
                ? (this.convertedPriceMinPerMeter ?? this.priceRange.min_per_meter ?? 0)
                : (this.convertedPriceMin ?? this.priceRange.min ?? 0);
            const rawMax = this.localSelectedPricePerMeter
                ? (this.convertedPriceMaxPerMeter ?? this.priceRange.max_per_meter ?? 0)
                : (this.convertedPriceMax ?? this.priceRange.max ?? 0);

            // Align range boundaries to step multiples so snapping works correctly
            const sliderMin = Math.floor(rawMin / STEP) * STEP;
            const sliderMax = Math.ceil(rawMax / STEP) * STEP;

            if (sliderMin >= sliderMax) return;

            const startMin = this.localSelectedMinPrice
                ? Math.round(this.localSelectedMinPrice / STEP) * STEP
                : sliderMin;
            const startMax = this.localSelectedMaxPrice
                ? Math.round(this.localSelectedMaxPrice / STEP) * STEP
                : sliderMax;

            let input0 = document.querySelector(".input-number-0");
            let input1 = document.querySelector(".input-number-1");

            // keyboardDefaultStep as % of range so one arrow key = one STEP unit
            const keyStep = sliderMax > sliderMin
                ? Math.max(0.01, (STEP / (sliderMax - sliderMin)) * 100)
                : 1;

            noUiSlider.create(priceSlider, {
                start: [startMin, startMax],
                connect: true,
                step: STEP,
                keyboardDefaultStep: keyStep,
                range: { min: [sliderMin], max: [sliderMax] }
            });

            // update: sync DOM inputs at each step during drag, no API call
            priceSlider.noUiSlider.on("update", (values, handle) => {
                const val = Math.round(values[handle]);
                if (handle === 0) { if (input0) input0.value = val; }
                else              { if (input1) input1.value = val; }
            });

            // end: fired on release — update Vue data, watcher triggers scheduleLiveCount()
            priceSlider.noUiSlider.on("end", (values, handle) => {
                const val = Math.round(values[handle]);
                if (handle === 0) { if (input0) input0.value = val; this.localSelectedMinPrice = val; }
                else              { if (input1) input1.value = val; this.localSelectedMaxPrice = val; }
            });

            const priceStart = document.getElementById("price-start");
            const priceEnd   = document.getElementById("price-end");
            if (priceStart && priceEnd) {
                const setPriceValues = () => {
                    const s = priceStart.value || null;
                    const e = priceEnd.value || null;
                    if (s && e) priceSlider.noUiSlider.set([s, e]);
                };
                priceStart.addEventListener("change", setPriceValues);
                priceEnd.addEventListener("change", setPriceValues);
            }
        },

        async _convertPriceRange() {
            const range = this.priceRange;
            if (!range || (!range.min && !range.max)) return;
            try {
                const response = await axios.get('/api/v1/currencies/convert', {
                    params: {
                        filtrationBaseMaxPrice: range.max,
                        filtrationBaseMinPrice: range.min,
                        currency: window.currentCurrency
                    }
                });
                this.convertedPriceMin = response.data.minPrice;
                this.convertedPriceMax = response.data.maxPrice;

                if (range.max_per_meter) {
                    const r2 = await axios.get('/api/v1/currencies/convert', {
                        params: {
                            filtrationBaseMaxPrice: range.max_per_meter,
                            filtrationBaseMinPrice: range.min_per_meter,
                            currency: window.currentCurrency
                        }
                    });
                    this.convertedPriceMinPerMeter = r2.data.minPrice;
                    this.convertedPriceMaxPerMeter = r2.data.maxPrice;
                }
            } catch (e) {
                console.error('Price range conversion failed:', e);
                // fallback: use DB values as-is
            }
        },

        // Sync local ↔ store with watcher guard
        syncFromStore(key, value) {
            this.turnOnWatchers = false;
            this[key] = value;
            this.$nextTick(() => { this.turnOnWatchers = true; });
        },

        _restoreFromUrl() {
            const params = new URLSearchParams(window.location.search);

            const parseJson = (key, fallback) => {
                const val = params.get(key);
                if (val === null || val === '' || val === 'null') return fallback;
                try { return JSON.parse(val); } catch { return fallback; }
            };

            const ptIds = parseJson('propertyTypesIds', []);
            this.localSelectedPropertyTypes = this.allPropertyTypes.filter(x => ptIds.includes(x.id));

            const dIds = parseJson('districtsIds', []);
            this.localSelectedDistricts = this.allDistricts.filter(x => dIds.includes(x.id));

            const bIds = parseJson('buildersIds', []);
            this.localSelectedBuilders = this.allBuilders.filter(x => bIds.includes(x.id));

            const cIds = parseJson('complexesIds', []);
            this.localSelectedComplexes = this.allComplexes.filter(x => cIds.includes(x.id));

            this.localSelectedBedroomsNumbers = parseJson('bedroomsNumbers', []).map(Number);
            this.localSelectedBathroomsNumbers = parseJson('bathroomsNumbers', []).map(Number);

            const restoredIds = parseJson('personalIds', []);
            this.localSelectedPersonalId = restoredIds.length ? restoredIds.join(', ') : '';

            const isFinishedVal = params.get('isFinished');
            if (isFinishedVal === 'true' || isFinishedVal === '1') {
                this.localSelectedIsFinished = true;
                this.isFinished = true; this.notFinished = false;
            } else if (isFinishedVal === 'false' || isFinishedVal === '0') {
                this.localSelectedIsFinished = false;
                this.isFinished = false; this.notFinished = true;
            } else {
                this.localSelectedIsFinished = null;
                this.isFinished = false; this.notFinished = false;
            }

            this.localSelectedHighestPrice = parseJson('highestPrice', null);
            this.localSelectedLowestPrice  = parseJson('lowestPrice', null);
            this.localSelectedIsNew        = parseJson('isNew', null);
            this.localSelectedIsPopular    = parseJson('isPopular', null);

            this.localSelectedFurnitureType            = params.get('furnitureType') || null;
            this.localSelectedTagsIds                  = parseJson('tagsIds', []);
            this.localSelectedConvenienceGroupIds      = parseJson('convenienceGroupIds', []);
            this.localSelectedStandaloneConvenienceIds = parseJson('standaloneConvenienceIds', []);
            this.localSelectedPricePerMeter            = parseJson('pricePerMeter', false);

            // Restore price inputs from the correct URL params depending on mode
            if (this.localSelectedPricePerMeter) {
                const minPM = params.get('minPricePerMeter');
                this.localSelectedMinPrice = minPM ? Number(minPM) : '';
                const maxPM = params.get('maxPricePerMeter');
                this.localSelectedMaxPrice = maxPM ? Number(maxPM) : '';
            } else {
                const minP = params.get('minPrice');
                this.localSelectedMinPrice = minP ? Number(minP) : '';
                const maxP = params.get('maxPrice');
                this.localSelectedMaxPrice = maxP ? Number(maxP) : '';
            }

            this.$store.dispatch('filtration/updateSelectedFilters', {
                selectedPropertyTypes:            this.localSelectedPropertyTypes,
                selectedDistricts:                this.localSelectedDistricts,
                selectedBuilders:                 this.localSelectedBuilders,
                selectedComplexes:                this.localSelectedComplexes,
                selectedBedroomsNumbers:          this.localSelectedBedroomsNumbers,
                selectedBathroomsNumbers:         this.localSelectedBathroomsNumbers,
                selectedPersonalId:               this.localSelectedPersonalId,
                selectedIsFinished:               this.localSelectedIsFinished,
                selectedMinPrice:                 this.localSelectedMinPrice !== '' ? Number(this.localSelectedMinPrice) : null,
                selectedMaxPrice:                 this.localSelectedMaxPrice !== '' ? Number(this.localSelectedMaxPrice) : null,
                selectedHighestPrice:             this.localSelectedHighestPrice,
                selectedLowestPrice:              this.localSelectedLowestPrice,
                selectedIsNew:                    this.localSelectedIsNew,
                selectedIsPopular:                this.localSelectedIsPopular,
                selectedFurnitureType:            this.localSelectedFurnitureType,
                selectedTagsIds:                  this.localSelectedTagsIds,
                selectedConvenienceGroupIds:      this.localSelectedConvenienceGroupIds,
                selectedStandaloneConvenienceIds: this.localSelectedStandaloneConvenienceIds,
                selectedPricePerMeter:            this.localSelectedPricePerMeter,
            });
        },
    },
    watch: {
        // Per m² toggle — reinit slider with different range (C3)
        localSelectedPricePerMeter(newVal) {
            if (this.turnOnWatchers) {
                // Reset price inputs so slider reinits with the full range for the new mode
                this.localSelectedMinPrice = '';
                this.localSelectedMaxPrice = '';
                this.initSlider();
                this.setSelectedPricePerMeterToStore({selectedPricePerMeter: newVal});
                this.scheduleLiveCount();
            }
        },

        // Builder → filter complexes (C1): remove selected complexes no longer in filteredComplexes
        localSelectedBuilders(newVal) {
            if (this.turnOnWatchers) {
                this.setSelectedBuildersToStore({selectedBuilders: newVal});
                // Deselect complexes that no longer belong to any selected builder
                if (newVal.length > 0) {
                    const builderIds = newVal.map(b => b.id);
                    const stillValid = this.localSelectedComplexes.filter(c => this.complexBuilderIds(c).some(id => builderIds.includes(id)));
                    if (stillValid.length !== this.localSelectedComplexes.length) {
                        this.localSelectedComplexes = stillValid;
                    }
                }
                this.scheduleLiveCount();
            }
        },
        selectedBuildersFromStore(newVal) { this.syncFromStore('localSelectedBuilders', Array.isArray(newVal) ? [...newVal] : []); },

        localSelectedPropertyTypes(newVal) {
            if (this.turnOnWatchers) { this.setSelectedPropertyTypesToStore({selectedPropertyTypes: newVal}); this.scheduleLiveCount(); }
        },
        selectedPropertyTypesFromStore(newVal) { this.syncFromStore('localSelectedPropertyTypes', Array.isArray(newVal) ? [...newVal] : []); },

        localSelectedDistricts(newVal) {
            if (this.turnOnWatchers) { this.setSelectedDistrictsToStore({selectedDistricts: newVal}); this.scheduleLiveCount(); }
        },
        selectedDistrictsFromStore(newVal) { this.syncFromStore('localSelectedDistricts', Array.isArray(newVal) ? [...newVal] : []); },

        localSelectedComplexes(newVal) {
            if (this.turnOnWatchers) { this.setSelectedComplexesToStore({selectedComplexes: newVal}); this.scheduleLiveCount(); }
        },
        selectedComplexesFromStore(newVal) { this.syncFromStore('localSelectedComplexes', Array.isArray(newVal) ? [...newVal] : []); },

        localSelectedBedroomsNumbers(newVal) {
            if (this.turnOnWatchers) { this.setSelectedBedroomsNumbersToStore({selectedBedroomsNumbers: [...newVal]}); this.scheduleLiveCount(); }
        },
        selectedBedroomsNumbersFromStore(newVal) { this.syncFromStore('localSelectedBedroomsNumbers', Array.isArray(newVal) ? [...newVal] : []); },

        localSelectedBathroomsNumbers(newVal) {
            if (this.turnOnWatchers) { this.setSelectedBathroomsNumbersToStore({selectedBathroomsNumbers: [...newVal]}); this.scheduleLiveCount(); }
        },
        selectedBathroomsNumbersFromStore(newVal) { this.syncFromStore('localSelectedBathroomsNumbers', Array.isArray(newVal) ? [...newVal] : []); },

        localSelectedPersonalId(newVal) {
            if (this.turnOnWatchers) { this.setSelectedPersonalIdToStore({selectedPersonalId: newVal}); this.scheduleLiveCount(); }
        },
        selectedPersonalIdFromStore(newVal) { this.syncFromStore('localSelectedPersonalId', newVal); },

        localSelectedIsFinished(newVal) {
            if (this.turnOnWatchers) { this.setSelectedIsFinishedToStore({selectedIsFinished: newVal}); this.scheduleLiveCount(); }
        },
        selectedIsFinishedFromStore(newVal) { this.syncFromStore('localSelectedIsFinished', newVal); },

        localSelectedMinPrice(newVal) {
            if (this.turnOnWatchers) { this.setSelectedMinPriceToStore({selectedMinPrice: newVal}); this.scheduleLiveCount(); }
        },
        selectedMinPriceFromStore(newVal) { this.syncFromStore('localSelectedMinPrice', newVal); },

        localSelectedMaxPrice(newVal) {
            if (this.turnOnWatchers) { this.setSelectedMaxPriceToStore({selectedMaxPrice: newVal}); this.scheduleLiveCount(); }
        },
        selectedMaxPriceFromStore(newVal) { this.syncFromStore('localSelectedMaxPrice', newVal); },

        localSelectedHighestPrice(newVal) {
            if (this.turnOnWatchers) {
                this.setSelectedIsPopularToStore({selectedIsPopular: !newVal});
                this.setSelectedIsNewToStore({selectedIsNew: !newVal});
                this.setSelectedLowestPriceToStore({selectedLowestPrice: !newVal});
                this.setSelectedHighestPriceToStore({selectedHighestPrice: newVal});
                this.scheduleLiveCount();
            }
        },
        selectedHighestPriceFromStore(newVal) { this.syncFromStore('localSelectedHighestPrice', newVal); },

        localSelectedLowestPrice(newVal) {
            if (this.turnOnWatchers) {
                this.setSelectedIsPopularToStore({selectedIsPopular: !newVal});
                this.setSelectedIsNewToStore({selectedIsNew: !newVal});
                this.setSelectedLowestPriceToStore({selectedLowestPrice: newVal});
                this.setSelectedHighestPriceToStore({selectedHighestPrice: !newVal});
                this.scheduleLiveCount();
            }
        },
        selectedLowestPriceFromStore(newVal) { this.syncFromStore('localSelectedLowestPrice', newVal); },

        localSelectedIsNew(newVal) {
            if (this.turnOnWatchers) {
                this.setSelectedIsPopularToStore({selectedIsPopular: !newVal});
                this.setSelectedIsNewToStore({selectedIsNew: newVal});
                this.setSelectedLowestPriceToStore({selectedLowestPrice: !newVal});
                this.setSelectedHighestPriceToStore({selectedHighestPrice: !newVal});
                this.scheduleLiveCount();
            }
        },
        selectedIsNewFromStore(newVal) { this.syncFromStore('localSelectedIsNew', newVal); },

        localSelectedIsPopular(newVal) {
            if (this.turnOnWatchers) {
                this.setSelectedIsPopularToStore({selectedIsPopular: newVal});
                this.setSelectedIsNewToStore({selectedIsNew: !newVal});
                this.setSelectedLowestPriceToStore({selectedLowestPrice: !newVal});
                this.setSelectedHighestPriceToStore({selectedHighestPrice: !newVal});
                this.scheduleLiveCount();
            }
        },
        selectedIsPopularFromStore(newVal) { this.syncFromStore('localSelectedIsPopular', newVal); },

        localSelectedFurnitureType(newVal) {
            if (this.turnOnWatchers) { this.setSelectedFurnitureTypeToStore({selectedFurnitureType: newVal}); this.scheduleLiveCount(); }
        },
        selectedFurnitureTypeFromStore(newVal) { this.syncFromStore('localSelectedFurnitureType', newVal); },

        localSelectedTagsIds(newVal) {
            if (this.turnOnWatchers) { this.setSelectedTagsIdsToStore({selectedTagsIds: [...newVal]}); this.scheduleLiveCount(); }
        },
        selectedTagsIdsFromStore(newVal) { this.syncFromStore('localSelectedTagsIds', Array.isArray(newVal) ? [...newVal] : []); },

        localSelectedConvenienceGroupIds(newVal) {
            if (this.turnOnWatchers) { this.setSelectedConvenienceGroupIdsToStore({selectedConvenienceGroupIds: [...newVal]}); this.scheduleLiveCount(); }
        },
        selectedConvenienceGroupIdsFromStore(newVal) { this.syncFromStore('localSelectedConvenienceGroupIds', Array.isArray(newVal) ? [...newVal] : []); },

        localSelectedStandaloneConvenienceIds(newVal) {
            if (this.turnOnWatchers) { this.setSelectedStandaloneConvenienceIdsToStore({selectedStandaloneConvenienceIds: [...newVal]}); this.scheduleLiveCount(); }
        },
        selectedStandaloneConvenienceIdsFromStore(newVal) { this.syncFromStore('localSelectedStandaloneConvenienceIds', Array.isArray(newVal) ? [...newVal] : []); },

        selectedPricePerMeterFromStore(newVal) { this.syncFromStore('localSelectedPricePerMeter', newVal); },
    },
    async mounted() {
        await this.$nextTick();

        this.turnOnWatchers = false;
        this._restoreFromUrl();
        await this._convertPriceRange();
        this.initSlider();
        this.turnOnWatchers = true;

        this.fetchLiveCount();

        this._onSelectAreaSubmitted = ({ detail }) => {
            const ids = detail.ids || [];
            const selected = ids.length > 0
                ? this.allDistricts.filter(d => ids.includes(d.id))
                : [];
            this.$store.dispatch('filtration/setSelectedDistricts', { selectedDistricts: selected });
            this.redirectToPropertiesPage();
        };
        window.addEventListener('select-area-submitted', this._onSelectAreaSubmitted);
    },

    beforeDestroy() {
        window.removeEventListener('select-area-submitted', this._onSelectAreaSubmitted);
    },
}
</script>

<style scoped>
.d-none {
    display: none;
}
.custom-select-filter__title {
    overflow: hidden;
}
</style>
